import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentSettingsService {


  constructor(private http: HttpClient) { }

  public getMaintenanceMode(): Observable<boolean> {
    return this.http.get<boolean>(environment.apiURL + '/EnvironmentInfo/MaintenanceMode');
  }

  /**
   * The cutover switch for the 2026 grievance form. True means the new pages answer the old public
   * routes /ogc/grievance and /ogc/file. Backed by a Portals.PortalSettings row so it can be
   * flipped without a deploy — see the Public API's SystemRepository.Grievance2026Enabled.
   *
   * Callers should go through GrievanceCutoverService rather than calling this directly; it caches
   * the answer and supplies the fail-closed fallback.
   */
  public getGrievance2026Enabled(): Observable<boolean> {
    return this.http.get<boolean>(environment.apiURL + '/EnvironmentInfo/Grievance2026Enabled');
  }

  /**
   * The public reCAPTCHA Enterprise site key for the 2026 grievance form. Public by definition — it
   * is embedded in the page for every visitor. The API key and project id stay server-side and are
   * never exposed by any endpoint (decision D9).
   */
  public getGrievance2026RecaptchaSiteKey(): Observable<string> {
    return this.http.get(
      environment.apiURL + '/EnvironmentInfo/Grievance2026RecaptchaSiteKey',
      { observe: 'body', responseType: 'text' as 'text' });
  }

  public getEFileMessaage(): Observable<string> {
    return this.http.get(environment.apiURL + '/EnvironmentInfo/EFileMessaage', { observe: 'body', responseType: 'text' as 'text'});
  }

  public getIPAddress()
  {
    return this.http.get("https://api.ipify.org/?format=json");
  }
}
